import { toast } from "react-toastify"
import { emailRegex, phoneRegex } from "./constants"

export const validateFormRequest = (name: string, email: string, phone: string, message: string) => {
  if (name.length === 0) {
    toast.error("Please, provide your Name.")
    return false
  }
  if (!emailRegex.test(email)) {
    toast.error("Please, provide correct Email Address.") 
    return false
  }
  if (!phoneRegex.test(phone)) {
    toast.error("Please, provide correct Mobile number.")
    return false
  }
  if (message.length === 0) {
    toast.error("Please, provide your Request.")
    return false
  }
  if (message.length > 1024) {
    toast.error("Your Request is too long. Please, make it a bit shorter.")
    return false
  }
  return true
}